import { useRef, useState } from 'react';

export default function useRefState<T>(initialState?: T): [() => T, (arg: T | ((arg: T) => T)) => void] {
  const [, setState] = useState<T>(initialState);
  const stateRef = useRef<T>(initialState);

  function _setState(_state: T | ((a: T) => T)) {
    let newState: any;

    if (typeof _state !== 'function') {
      setState(_state);
      stateRef.current = _state;
    }
    if (typeof _state === 'function') {
      newState = (_state as any)(stateRef.current);
      stateRef.current = newState;
      setState((state) => {
        return stateRef.current;
      });
    }
  }

  function getState(): T {
    return stateRef.current;
  }

  return [getState, _setState];
}
